<template>
  <div
    v-if="price"
    class="main-product__breadpay main-product__description hummWidget"
    :id="`hummWidget-${sku}`"
    :style="{ display: 'none', cursor: 'pointer' }"
    @click="handleClick"
  >
    <div class="btn_layout" :style="{ padding: '5px 0px' }">
      <span>AS LOW AS </span>
      <span>
        <img
          src="https://d3r8vfwymw8fxa.cloudfront.net/content/images/humm_logo.png"
          alt="Humm Logo"
          class="flexifi-widget-logo"
          :style="{ filter: 'brightness(0) saturate(100%)', width: 'auto', height: '16px' }"
        >
      </span>
    </div>
    <p class="btn_price">
      <span :id="`priceValue-${sku}`"></span>
      <span id="financing-disclosure">*</span>
    </p>
  </div>
  <div :id="`priceInfo-${sku}`" class="priceInfo" :style="{ display: 'none' }" />
</template>

<script>
export default {
  name: 'HummWidget',
  props: {
    price: {
      type: [String, Number],
      required: true,
    },
    sku: {
      type: String,
      required: true,
    },
  },
  mounted() {
    const scriptId = `humm-widget-script-${this.sku}`;
    const priceInfoId = `priceInfo-${this.sku}`;
    const priceValueId = `priceValue-${this.sku}`;
    const widgetId = `hummWidget-${this.sku}`;

    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = `https://d3r8vfwymw8fxa.cloudfront.net/content/scripts/flexifi-widget.js?id=001OO00000M5vdiYAB&productPrice=${this.price / 100}&price-selector=%23${priceInfoId}`;
      script.async = true;

      script.onload = () => {
        const priceInfo = document.getElementById(priceInfoId);
        if (priceInfo) {
          const observer = new MutationObserver(() => {
            const priceEl = priceInfo.querySelector('b');
            if (priceEl) {
              const displayPrice = priceEl.textContent.trim();
              document.getElementById(widgetId).style.display = 'block';
              document.getElementById(priceValueId).innerHTML = `${displayPrice} / MONTH`;
              observer.disconnect();
            }
          });

          observer.observe(priceInfo, {
            childList: true,
            subtree: true,
          });
        }
      };

      document.getElementById(priceInfoId).appendChild(script);
    }

    // Single MutationObserver for handling duplicate elements
    const observer = new MutationObserver(() => {
      // Check and remove duplicate mfp-bg elements
      const bgElements = Array.from(document.querySelectorAll('.mfp-bg'));
      const readyBGs = bgElements.filter(el => el.classList.contains('mfp-ready'));
      if (readyBGs.length > 1) {
        readyBGs.slice(1).forEach(el => el.remove());
      }

      // Check and remove duplicate mfp-wrap elements
      const wrapElements = Array.from(document.querySelectorAll('.mfp-wrap'));
      const readyWraps = wrapElements.filter(el =>
        el.classList.contains('mfp-ready') &&
        el.classList.contains('mfp-close-btn-in') &&
        el.classList.contains('mfp-auto-cursor')
      );
      if (readyWraps.length > 1) {
        readyWraps.slice(1).forEach(el => el.remove());
      }
    });

    observer.observe(document.body, {
      childList: true,
      attributes: true,
      subtree: true,
      attributeFilter: ['class'], // Watch class mutations
    });

    // Cleanup the observer on page unload
    window.addEventListener('beforeunload', () => {
      observer.disconnect();
    });
  },
  methods: {
    handleClick(event) {
      event.preventDefault();
      event.stopPropagation();
      const sku = this.sku;
      const priceInfoContainer = document.getElementById(`priceInfo-${sku}`);
      const priceInfo = priceInfoContainer.querySelector('#flexifi-tag');
      if (priceInfo) priceInfo.click();
    },
  },
};
</script>

<style scoped>
/* Add custom styles here if necessary */
</style>
